import React, { useState, useEffect } from 'react'
import { Chart } from 'primereact/chart'
import { chartColorVariants, type ChartDataProps } from './chartsUtil'
import ChartContainer from './ChartContainer'

interface PieChartProps {
    data?: ChartDataProps
}

const PieChart = ({ data }: PieChartProps) => {
    const [chartData, setChartData] = useState<ChartDataProps | Record<string, unknown> | undefined>({})
    const [chartOptions, setChartOptions] = useState<Record<string, unknown>>({})

    useEffect(() => {
        const options = {
            maintainAspectRatio: false,
            responsive: true,
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                    },
                },
            },
        }

        const finalisedChartData = data
        const ds = data?.datasets?.[0] ?? {}
        const dsData = (ds['data'] as unknown[]) ?? []

        ds['borderColor'] = []
        ds['backgroundColor'] = []

        const documentStyle = getComputedStyle(document.documentElement)

        const borderColors: string[] = []
        const backgroundColors: string[] = []

        for (let i = 0; i < dsData.length; i++) {
            const colorVariant = chartColorVariants[i]

            if (colorVariant) {
                borderColors.push(
                    documentStyle.getPropertyValue('--bs-' + colorVariant)
                )
                backgroundColors.push(
                    documentStyle.getPropertyValue('--bs-' + colorVariant) +
                        '80'
                )
            }
        }

        ds['borderColor'] = borderColors
        ds['backgroundColor'] = backgroundColors

        setChartData(finalisedChartData)
        setChartOptions(options)
    }, [data])

    return (
        <ChartContainer className="w-100 h-100" style={{ minHeight: 0 }}>
            <Chart
                type="pie"
                data={chartData}
                options={chartOptions}
                className="w-100 h-100"
            />
        </ChartContainer>
    )
}

export default PieChart
